const Advert = require('./advert');

class Advert_N_Two extends Advert {
  constructor() {
    super();
    this.data;
    this.ex;
    this.admData;
    this.GD_params;
    this.DOM;
    this.curnewsinfoid = $('#currentinfoid').val();
    this.categoryIdNew = $('#categoryIdNew').val();
  }

  SetDOM() {
    if (this.admData.gameId) {
      this._gameId = this.admData.gameId;
    } else {
      this._gameId = $('#_gameId').val() > 0 ? $('#_gameId').val() : 0;
    }
    const exposestat = this.ag_stat.createPageStat({
      ag_extend: 'advert',
      ag_a1: this.getAGA1(this.data.adpId),
      ag_a2: 'other',
      ag_a4: 4,
      ag_a5: this.admData.admId,
      ag_a7: this.data.odPlanId,
      ag_a8: this.data.adPutType || '',
      ag_a9: this.categoryIdNew,
    }, 'expose');
    const exposestat1 = this.ag_stat.createPageStat({
      ag_extend: 'advert',
      ag_a1: this.getAGA1(this.data.adpId),
      ag_a2: 'btn',
      ag_a4: 4,
      ag_a5: this.admData.admId,
      ag_a7: this.data.odPlanId,
      ag_a8: this.data.adPutType || '',
      ag_a9: this.categoryIdNew,
    }, 'expose');
    this.DOM = $(`<div class="ad-custom-two ad-custom" ${exposestat}>
    <div class="content" style="background-image: url(${this.ex.logoImageUrl});">
      <div class="bg"></div>
      <div class="title">${this.ex.subTitle}</div>
      <div class="desc">${this.ex.mainTitle}</div>
    </div>
    <div class="extra">
      <ul class="tips">
        <li>${this.ex.mainText1}</li>
        <li>${this.ex.mainText2}</li>
        <li>${this.ex.mainText3}</li>
      </ul>
      <div class="btn" ${exposestat1}>
        ${this.ex.buttonText}
        <div class="btn-qrcode-box">
          <div class="tip">扫一扫，立即获取</div>
          <div class="qrcode"></div>
        </div>
      </div>
    </div>
  </div>`);
    this.InitEvent();
  }

  InitEvent() {
    this.InitButtonEvent();
  }

  InitButtonEvent() {
    this.DOM.on('click', e => {
      this.pullUp(this.admData.gameId, `ag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`, this.ex.qdownCh, this.gameBaseInfo.packageproperty);
      const agStatData = {
        ag_extend: 'advert',
        ag_a1: this.getAGA1(this.data.adpId),
        ag_a2: 'other',
        ag_a3: 1,
        ag_a4: 4,
        ag_a5: this.admData.admId,
        ag_a7: this.data.odPlanId,
        ag_a8: this.data.adPutType || '',
        ag_a9: this.categoryIdNew,
      };
      if ($(e.target).hasClass('btn')) {
        agStatData.ag_a2 = 'btn';
      }
      this.ag_stat.customStatPortal(agStatData, 'quick_down');
    });
    if (this.IsInPc() && window.xMan_qrcode) {
      this.DOM.find('.qrcode').each((idx, elem) => {
        let ch = 'OK_2003';
        if (window.location.pathname.indexOf('news') > -1) {
          ch = 'OK_2011';
        }
        const downUrl = 'https://web.9game.cn/share?pageType=game_detail&ch=' + ch + '&gameId=' + this._gameId + '&pullUpFrom=ugt_game_highspeed_' + this._gameId + '&opt=download';
        const qrcode = window.xMan_qrcode({
          render: 'canvas',
          width: 140,
          height: 140,
          correctLevel: 0,
          text: downUrl,
        });
        $(elem).append(qrcode);
      });
    }
  }
}

module.exports = Advert_N_Two;



// WEBPACK FOOTER //
// ./lib/js/module/m_advert/module/advert_n_two.js